import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import WidgetConversation from "./WidgetConversation";
import {
  AddChatWidgetGroups,
  chatWidgetLogin,
  createChatWidgetUser,
} from "../../../redux/actions/chatActions";
import arrowRight from "../../../assets/icons/arrowIcone.svg";
import moment from "moment";

const WidgetForm = () => {
  const dispatch = useDispatch();
  const [companyId, setCompanyId] = useState(
    window.localStorage.getItem("companyid")
  );
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [toggle, setToggle] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [groupId, setGroupId] = useState("");
  const loginRes = useSelector((state) => state.chat.loginWidgetData);
  const newUserRes = useSelector((state) => state.chat.chatWidgetAddUserRes);
  const fetchCompanyDetails = useSelector(
    (state) => state.user.FetchCompanyDetails
  );

  const addGroupsResponse = useSelector(
    (state) => state.chat.addGroupsWidgetResponse
  );

  useEffect(() => {
    if (addGroupsResponse?.status && currentUserId) {
      const newGroupId = addGroupsResponse?.data?.groupid;
      window.localStorage.setItem("group-id", newGroupId);
      setGroupId(newGroupId);
      setToggle(true);
      setShowLoader(false);
    }
  }, [addGroupsResponse]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.action === "clearLocalStorage") {
        window.localStorage.removeItem("group-id");
        window.localStorage.removeItem("firstname");
        window.localStorage.removeItem("userid");
        window.localStorage.removeItem("companyid");
        window.localStorage.removeItem("token");
        console.log("Iframe localStorage cleared");
      }
    };

    window.addEventListener("message", handleMessage, false);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const currentUserId = window.localStorage.getItem("userid");
  const token = window.localStorage.getItem("token");
  const firstName = window.localStorage.getItem("firstname");

  // Handle user auto-login
  useEffect(() => {
    if (currentUserId && token && companyId && firstName) {
      setToggle(true);
      setShowLoader(false);
    }
  }, [currentUserId, token, companyId, firstName]);

  // Update companyId based on fetched company details
  useEffect(() => {
    if (fetchCompanyDetails?.status) {
      setCompanyId(fetchCompanyDetails.data[0]?.companyid);
      window.localStorage.setItem(
        "companyid",
        fetchCompanyDetails.data[0]?.companyid
      );
    }
  }, [fetchCompanyDetails]);

  let businessSupportId='';

  switch (window.location.origin) {
    case process.env.REACT_APP_DEV_URL:
      businessSupportId = process.env.REACT_APP_DEV_BUSINESS_SUPPORT_ID;
      break;
    case process.env.REACT_APP_TEST_URL:
      businessSupportId = process.env.REACT_APP_TEST_BUSINESS_SUPPORT_ID;
      break;
    case process.env.REACT_APP_UAT_PARTNER_URL:
      businessSupportId = process.env.REACT_APP_UAT_PARTNER_BUSINESS_SUPPORT_ID;
      break;
    case process.env.REACT_APP_UAT_PARTNER_PLUS_URL:
      businessSupportId =
        process.env.REACT_APP_UAT_PARTNER_PLUS_BUSINESS_SUPPORT_ID;
      break;
    case process.env.REACT_APP_UAT_PARTNER_PRM_URL:
      businessSupportId =
        process.env.REACT_APP_UAT_PARTNER_PRM_BUSINESS_SUPPORT_ID;
      break;
    default:
      console.warn("No matching URL found for business support ID.");
      break;
  }

  console.log(`Business Support ID: ${businessSupportId}`);

  useEffect(() => {
    const handleLogin = async () => {
      if (!loginRes?.status) {
        setShowLoader(false);
        setToggle(true);
        return;
      }

      const { userid, iscurrentcompany, firstname, sessionid } =
        loginRes.data[0];
      const token = loginRes.data[2];

      window.localStorage.setItem("userid", userid);
      window.localStorage.setItem("companyid", iscurrentcompany);
      window.localStorage.setItem("firstname", firstname);
      window.localStorage.setItem("token", token);
      window.localStorage.setItem("session-id", sessionid);

      try {
        // Fetch active users
        // const response = await axios.post(
        //   `${API_URL}/api/User/FetchActiveUsers`,
        //   { companyid: iscurrentcompany },
        //   { headers: { "Content-Type": "application/json" } }
        // );

        // const activeAdmin = response.data.data.filter(
        //   (val) => val.roleid === "08da3f0d-0371-4dd3-8c86-e51222d56188"
        // );
        // // console.log("activeAdmin", activeAdmin);
        // if (activeAdmin.length === 0) {
        //   setShowLoader(false);
        //   setToggle(true);
        //   return;
        // }

        // const randomIndex = Math.floor(Math.random() * activeAdmin.length);
        // const randomUserId = activeAdmin[randomIndex]?.userid;

        // if (randomUserId) {
        const groupUser = [
          { groupmember: userid },
          { groupmember: businessSupportId },
        ];
        const groupName = `${firstname}(website)`;
        const formattedDateTime = moment().format("Do MMMM YYYY [at] HH:mm a");
        const groupDescription = `Group created by ${firstname} in ${formattedDateTime}`;

        // Dispatch action to create the chat group
        dispatch(
          AddChatWidgetGroups(
            userid,
            groupName,
            groupDescription,
            "",
            groupUser,
            "SupportChat"
          )
        );
        // } else {
        //   setShowLoader(false);
        //   setToggle(true);
        // }
      } catch (error) {
        console.error("Error fetching active users or creating group:", error);
        setShowLoader(false);
        setToggle(true);
      }
    };

    handleLogin();
  }, [loginRes]);

  useEffect(() => {
    if (
      newUserRes?.message == "This Email Id Already Exist" ||
      newUserRes?.status
    ) {
      dispatch(chatWidgetLogin(email, "qazxsw@123", companyId));
    }
  }, [newUserRes]);

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !email) {
      setError("Please fill in both fields.");
      return;
    }
    setError("");
    setShowLoader(true);
    const payload = createChatWidgetPayload(name, email, companyId);
    dispatch(createChatWidgetUser(payload));
  };

  const chatWidgetArrowFun2 = () =>{
    return(
      <p>asc</p>
    )
  }

  const chatWidgetArrowFun = () => {
    return(
      <p style={{ margin: "0px", fontSize: "20px", paddingLeft: "20px" }}> ⟶ </p>
    )
  }
   
  console.log("asc66",chatWidgetArrowFun())
  console.log("asc662",chatWidgetArrowFun().props.children)

  return (
    <>
      {showLoader ? (
        <div
          className="text-center "
          style={{
            color: "#003766",
            fontSize: "14px",
            fontWeight: "700",
            marginTop: "35%",
          }}
        >
          <div className="chatMainLoaderDiv">
            <div class="chatLoader">
              <div class="chat-inner-circle"></div>
              <div class="chat-outer-circle"></div>
            </div>
          </div>
        </div>
      ) : !toggle ? (
        <form
          className="d-flex gap-4"
          style={{
            flexDirection: "column",
            padding: "15px 50px 50px",
            background: "#fff",
          }}
          onSubmit={handleSubmit}
        >
          <div className="chat-widget-header">
            Please, tell us your name and email to better support you.
          </div>
          {error && <div style={{ color: "red" }}>{error}</div>}
          <div className="pt-2">
            <input
              className="add-member-input-noborder add-member-input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              style={{ background: "transparent" }}
            />
            <hr className="my-1" />
            <p className="chat-widget-title mt-1">Name</p>
          </div>
          <div className="pt-2">
            <input
              className="add-member-input-noborder add-member-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ background: "transparent" }}
            />
            <hr className="my-1" />
            <p className="chat-widget-title mt-1">Email</p>
          </div>
          <button type="submit" className="chat-widget-start mt-2">
            {/* {"Start Conversation"} */}
            {/* {`${"Start Conversation"} ${chatWidgetArrowFun().props.children}`} */}
            Start Conversation {chatWidgetArrowFun()}
          </button>
        </form>
      ) : (
        <WidgetConversation
          currentUserId={currentUserId}
          groupId={groupId}
          setToggle={setToggle}
          token={token}
        />
      )}
    </>
  );
};

// Helper function to create chat widget user payload
const createChatWidgetPayload = (name, email, companyId) => ({
  companyid: companyId,
  roleid: process.env.REACT_APP_IS_VIEWER, //viewer role
  firstname: name,
  lastname: "",
  email,
  password: "qazxsw@123",
  abbreviation: "",
  phonenumber: "",
  address: "",
  ziPcode: "",
  taxnumber: "",
  securitynumber: "",
  paymentaccount: "",
  description: "",
  dateofbirth: "",
  jobpost: "",
  iscurrentcompany: companyId,
  isverified: 1,
  isrequiretimesheetapproval: 0,
  isallowmanualtime: 0,
  isdeleted: 0,
  imageurl: "",
  language: "English",
  billrate: "",
  contracttype: "",
  paymentperiod: "",
  type: "",
  wagerate: "",
  jobtypeid: "00000000-0000-0000-0000-000000000000",
  weekhours: "",
  timesheetapproval: 0,
  usertimeoff: [],
});

export default WidgetForm;
